import React, { Component } from 'react';
import axios from "axios";
import { toast } from "react-toastify";

import { API_URL, ERROR_HANDLE } from "../../../../../config/constants";
import ModalOverlay from "../../../../../components/UI/ModalOverlay";
import theme from '../../../../../Theme/theme';
import './style.css'
import TimePicker from "../../../../../components/TimePicker";
import DatePicker from "react-datepicker";
import moment from "moment-timezone";
import TimezonePicker from 'react-bootstrap-timezone-picker';
import { isValidEmail } from '../../../../../common/Utils';
import 'react-bootstrap-timezone-picker/dist/react-bootstrap-timezone-picker.min.css';
import SlideSwitch from "../../../../../components/SlideSwitch";

import { TimeFormats, VPTSessionLengths } from "../../../../../common/constants"

const TITLE = "BOOK A SESSION";

export default class AddBooking extends Component {

    state = {
        userEmail: "",
        duration: null,
        date: moment().set('hour', 0).set('minute', 0).set('second', 0),
        time: moment().set('hour', 0).set('minute', 0).format(TimeFormats.time_am_pm),
        timezone: null,
        progress: false,
        applyPackage: true,
        packageId: null,
        createTrainerAvailability: true,
        noCharge: false,
        skipUnAvailability: true
    }

    componentDidMount() {
        this.setState({
            trainerEmail: this.props.trainerEmail
        })
    }

    render() {
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                header={TITLE}
                headerStyle={style.headerStyle}
                headerBodyStyle={style.headerBodyStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                close={this.props.close}>
                <div>
                    {this.renderForm()}
                    {this.state.error != null && this.renderError()}
                    {this.renderActions()}
                </div>
            </ModalOverlay>
        )
    }

    renderForm = () => {
        return (
            <div>
                <div className="item">
                    <div className="label-style">User Email</div>
                    <input className="column-style input-style"
                        placeholder="Enter User's Email Address"
                        onChange={this.emailChange} />
                </div>
                <div className="item">
                    <div className="label-style">Date</div>
                    <div className="column-style">
                        <DatePicker
                            className="label-style"
                            locale="en-us"
                            selected={this.state.date}
                            onChange={this.dateChange} />
                    </div>
                </div>
                <div className="item">
                    <div className="label-style">Time</div>
                    <div className="column-style">
                        <TimePicker
                            type="start"
                            changeTime={this.timeChange}
                            currentTime={this.state.time}
                        />
                    </div>
                </div>
                <div className="item">
                    <div className="label-style">TimeZone</div>
                    <TimezonePicker
                        className="column-style"
                        absolute={true}
                        placeholder="Select TimeZone"
                        onChange={this.timezoneChange}
                    />
                </div>
                <div className="item">
                    <div className="label-style">Duration</div>
                    <div className="column-style">
                        {
                            VPTSessionLengths.map(length => this.renderDurationOptions(length))
                        }
                    </div>
                </div>
                <div className="item">
                    <div className="label-style">Don't Charge</div>
                    <SlideSwitch style={style.switchBtn} checked={this.state.noCharge} onClick={() => {
                        this.setState({
                            noCharge: !this.state.noCharge
                        })
                    }} />
                </div>
                <div className="item">
                    <div className="label-style">One-Off Availability</div>
                    <SlideSwitch style={style.switchBtn} checked={this.state.createTrainerAvailability} onClick={() => {
                        this.setState({
                            createTrainerAvailability: !this.state.createTrainerAvailability
                        })
                    }} />
                </div>
                <div className="item">
                    <div className="label-style">Skip Unavailability</div>
                    <SlideSwitch style={style.switchBtn} checked={this.state.skipUnAvailability} onClick={() => {
                        this.setState({
                            skipUnAvailability: !this.state.skipUnAvailability
                        })
                    }} />
                </div>
                <div className="item">
                    <div className="label-style">Apply Package</div>
                    <SlideSwitch style={style.switchBtn} checked={this.state.applyPackage} onClick={() => {
                        this.setState({
                            applyPackage: !this.state.applyPackage
                        })
                    }} />
                </div>
                <div className="item">
                    <div className="label-style">Package Id</div>
                    <input className="column-style input-style"
                        placeholder="Enter Package Id(Optional)"
                        onChange={this.packageIdChange} />
                </div>
            </div>
        )
    }

    renderError = () => {
        return <div style={{ marginTop: 30, color: 'red' }}>
            {this.state.error}
        </div>
    }

    renderActions = () => {
        return <div style={style.doneButtonWrapper}>
            <div style={style.action} onClick={this.book}>
                Book
            </div>
            <div style={style.action}
                onClick={this.props.close}>
                Close
            </div>
        </div>
    }

    renderDurationOptions = (value) => {
        let duration = this.state.duration;
        return <div className={`duration unselectable ${duration == value ? "duration-selected" : ""}`}
            onClick={() => {
                this.setState({
                    duration: value,
                    error: null
                })
            }}>{value}min</div>
    }

    timeChange = (day, type, time) => {
        this.setState({
            time: time,
            error: null
        })
    }

    dateChange = date => {
        this.setState({
            date: date,
            error: null
        })
    }

    emailChange = e => {
        this.setState({
            userEmail: e.target.value,
            error: null
        })
    }

    packageIdChange = e => {
        this.setState({
            packageId: e.target.value,
            error: null
        })
    }

    timezoneChange = timezone => {
        this.setState({
            timezone: timezone,
            error: null
        })
    }

    book = () => {
        if (this.state.progress) return
        let timeMoment = moment(this.state.time, TimeFormats.time_am_pm);
        let cloneDate = this.state.date.clone()
        cloneDate.set('h', timeMoment.get('h')).set('m', timeMoment.get('m')).set('s', 0)
        let invalid = true
        let error = null
        if (!isValidEmail(this.state.userEmail)) {
            error = "Please enter a valid user email"
        } else if (!isValidEmail(this.state.trainerEmail)) {
            error = "Trainer email is not valid"
        } else if (this.state.timezone == null) {
            error = "Please select the timezone of session"
        } else if (cloneDate.tz(this.state.timezone, true).isBefore(moment())) {
            error = "Please select a time in the future"
        } else if (this.state.duration == null) {
            error = "Please select the duration of session"
        } else if (this.state.packageId && isNaN(this.state.packageId)) {
            error = "Please enter a valid package id"
        } else {
            invalid = false
        }
        if (invalid) {
            this.setState({
                error: error
            })
        } else {
            this.setState({
                progress: true
            })
            let body = {
                trainerEmail: this.state.trainerEmail,
                userEmail: this.state.userEmail,
                fromTime: cloneDate.tz(this.state.timezone, true).format(TimeFormats.date),
                toTime: cloneDate.add(this.state.duration, 'm').tz(this.state.timezone, true).format(TimeFormats.date),
                userTimezone: this.state.timezone,
                source: "super-admin",
                applyPackage: this.state.applyPackage,
                noCharge: this.state.noCharge,
                createTrainerAvailability: this.state.createTrainerAvailability,
                skipUnAvailability: this.state.skipUnAvailability,
            }
            if (this.state.packageId)
                body.packageId = this.state.packageId;
            const toastId = toast.success('Booking...');
            axios.post(`${API_URL}/trainer/slot/user`, body, {
                headers: {
                    "x-access-token": localStorage.getItem("access_token")
                },
            }).then(() => {
                toast.dismiss(toastId);
                toast.success("Session booked successfully", { autoClose: 1000 })
                this.setState({
                    progress: false
                })
            }).catch(e => {
                toast.dismiss(toastId);
                this.setState({
                    progress: false
                })
                if (e.response.data && e.response.data.error) {
                    this.setState({
                        error: e.response.data.error
                    })
                }
                ERROR_HANDLE(e)
            })
        }
    }
}

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3,
        padding: 10
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
    },
    modalBody: {
        margin: 25,
        marginTop: 0,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    label: {
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
        marginLeft: 10,
        marginRight: 10
    },
    doneButtonWrapper: {
        width: 500,
        display: "flex",
        justifyContent: "space-around",
        marginTop: 40,
        alignItems: "center"
    },
    action: {
        marginLeft: 10,
        marginRight: 10,
        width: 100,
        alignSelf: 'center',
        backgroundColor: theme.color.teal,
        color: theme.color.white,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 5,
        paddingBottom: 5,
        borderRadius: 5
    },
    switchBtn: {
        flex: 2,
        alignItems: 'left',
    }
}